import { EProductTypeInternalName } from "@/3514/types"

const PRODUCT_TYPES_WITH_ENROLLMENTS: EProductTypeInternalName[] = [
    EProductTypeInternalName.Wiser,
    EProductTypeInternalName.WiserDemo,
    EProductTypeInternalName.SpotCoaching,
    EProductTypeInternalName.LeadershipCoaching,
    EProductTypeInternalName.ExecutiveCoaching
]

export { PRODUCT_TYPES_WITH_ENROLLMENTS }
